import { render, staticRenderFns } from "./CountryCodeSelector.vue?vue&type=template&id=28aeb48e&scoped=true&"
import script from "./CountryCodeSelector.vue?vue&type=script&lang=js&"
export * from "./CountryCodeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CountryCodeSelector.vue?vue&type=style&index=0&id=28aeb48e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aeb48e",
  null
  
)

export default component.exports